import { FC } from 'react';
import { Avatar, Badge, Button, ButtonProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface IFilterChipButtonProps extends ButtonProps {
	active?: boolean;
	onRemove?: () => void;
}

export const FilterChipButton: FC<IFilterChipButtonProps> = ({ active, onRemove, ...props }) => {
	return (
		<Badge
			badgeContent={
				<Avatar
					sx={{
						cursor: 'pointer',
						width: 18,
						height: 18,
						backgroundColor: 'common.black',
						color: 'common.white',
						borderStyle: 'solid',
						borderWidth: 1,
						borderColor: 'common.white'
					}}
					onClick={onRemove}
				>
					<CloseIcon color="inherit" sx={{ width: 14, height: 14 }} />
				</Avatar>
			}
			invisible={!active}
			overlap="rectangular"
			sx={{
				'& .MuiBadge-badge': {
					top: 4,
					right: 4
				}
			}}
		>
			<Button
				variant={active ? 'contained' : 'outlined'}
				color="secondary"
				size="small"
				data-testid="filtering-chip-button" // should be overriden by props
				{...props}
			/>
		</Badge>
	);
};
